import React, { Fragment } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import * as Icons from 'react-bootstrap-icons';

function PageTitle({ title, loading, className, subTitle = ''}) {
  return (
    <Fragment>
      {loading ? (
        <Skeleton variant="text" animation="wave" width={100} />
      ) : (
        <div className={`pageTitle ${className}`}>
          <span className="circle" />
          <p className="mx-1">{title}</p>
          {
            subTitle !== '' && (
              <>
                <span className="mx-1"><Icons.CaretLeft/></span>
                <span>{subTitle}</span>
              </>
            )
          }
        </div>
      )}
    </Fragment>
  );
}

export default PageTitle;
